import Vue from 'vue';
import _ from 'lodash';

const state =
{
    unreadChats: [],
    activeChannel: null,
    activeChannelInfos: {},
};

const actions =
{
//    fakeUpdateUnreadChats ({commit})
//    {
//        commit('FAKE_UPDATE_UNREAD_CHATS');
//    },

    setUnreadChats ({commit})
    {
        return new Promise((resolve, reject) =>
        {
            Vue.http.silent().get('/api/memberships/unread-chats')
            .then(response =>
            {
                commit('SET_UNREAD_CHATS', response.data);
                resolve(response.data);
            })
            .catch( error =>
            {
                reject('failed');
            })
        });
    },

    setActiveChannel ({commit}, channelId)
    {
        commit('SET_ACTIVE_CHANNEL', channelId);
    },

    setActiveChannelInfos ({commit}, channelInfos)
    {
        commit('SET_ACTIVE_CHANNEL_INFOS', channelInfos);
    }
};

const mutations =
{
    SET_UNREAD_CHATS(state, chats)
    {
        state.unreadChats = chats;
    },

    SET_ACTIVE_CHANNEL(state, channelId)
    {
        state.activeChannel = channelId;
    },

    SET_ACTIVE_CHANNEL_INFOS(state, channelInfos)
    {
        state.activeChannelInfos = channelInfos;
    },

//    FAKE_UPDATE_UNREAD_CHATS (state)
//    {
//        state.unreadChats.push({})
//    }
};

const getters =
{
    countUnread: state =>
    {
        return _.filter(state.unreadChats, item => item.channel.id !== state.activeChannel).length
    }
};

export default
{
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/chat.js